import SaveServiceRequest from "@/models/server/requests/SaveServiceRequest";

export default class SkipServiceRequest extends SaveServiceRequest {
    public lastServiceDate: Date | null = null;

    public lastServiceOperatingHours: number | null = null;
}